// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2eV8h3","iconContainer":"D3XhAv","iconContainerVisited":"_2gi1DE","icon":"H4CHfW","preTitle":"UJFY3i"};